export default "__VITE_ASSET__CRMA0tdk__"